import { UserContext } from "components/user"
import { useContext } from "react"


export default function useUser(){
    const user = useContext(UserContext);
    
    return user;
}